import script from "./goRinSyo0038.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0038.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0038.vue?vue&type=style&index=0&id=02962bf7&lang=scss"

const __exports__ = script;

export default __exports__